import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/layouts/login.vue").then(m => m.default || m))
}